var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinSidaWhite = function SvgMinSidaWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M12 10.68a4.4 4.4 0 1 1 0-8.8 4.4 4.4 0 0 1 0 8.8Zm0 11.031s-9.68 0-9.68-3.991 4.334-7.04 9.68-7.04 9.68 3.049 9.68 7.04S12 21.711 12 21.711Z"
  })));
};
export default SvgMinSidaWhite;